const isLocal = window.location.hostname.includes('localhost');

const config = {
  baseDomain: isLocal ? 'relume.localhost' : 'sitebuilder.engageleads.net',
  protocol: isLocal ? 'http' : 'https',
};

// Helper to build full subdomain URL
export const getSubdomainUrl = (subdomain) =>
  `${config.protocol}://${subdomain}.${config.baseDomain}`;

export default config;
